function About() {
  return (
    <section id="ABOUT">
      <span className="section_title">Our Story</span>
      <br />
      <span className="section_text auto_left">
        Decades ago in the village of Eguisheim on the Alsatian Wine Route of
        France, filled with it's concentric narrow streets lined with colorful
        roses, a great wise teacher arrived the village to host a teaching
        seminar.
        <br />
        <br />
        A town cryer was hired and he started going around the village making
        the arrival of the great teacher known as the meeting was scheduled for
        6 hours ahead of the great teachers arrival.
        <br />
        <br />
        On the scheduled time of the meeting, the great teacher arrived at the
        tent to start teaching and to his amazement, he only found a single man
        seated and waiting for the teacher.
        <br />
        <br />
        The teacher was surprised and asked the man, hey young man, this tent
        was meant to be filled with people waiting for me and why is it that
        you're the only one here?
        <br />
        <br />
        The man replied, hello great teacher I'm just a poor farmer and know
        nothing about seminars, but this I know, If I go out into the farm to
        feed my sheeps and only one shows up, I'll at least feed it!?
        <br />
        <br />
        The great teacher thought to himself, yea you're right young man!
        <br />
        <br />
        So the great teacher went on and started pouring out his wisdom on this
        young farmer, he kept on going and going for hours!
        <br />
        <br />
        After long hours of teaching, the farmer exclaimed! hello great teacher,
        if I go out to feed my sheeps and only one shows up, I'll at least feed
        it but I won't dump the whole pasture on a single sheep!
        <br />
        <br />
        The great teacher thought to himself and said, yeah you're right young
        man, I've poured out all my wisdom on you! now look for 10,000 young men
        like yourself and teach them all I've taught you!
        <br />
        <br />
        Here comes the Funkies!!! The Funkies are those 10,000 gifted students
        the young farmer imparted with the wisdom he got from the great
        teacher!!
        <br />
        <br />
        Funkies are a collection of 10,000 NFT’s that have their own unique
        designs and brilliance. There is an order of rarity that makes certain
        ones more valuable than the others. With minting these you have the
        chance of getting a super rare Funky, making minting these fun and
        exciting! Funkies are some of the rare pixelated art on the blockchain.
        <br />
        <br />
        The Funkies collectibles is a community of sparkling and clever
        creatures, its the community of wise teachers and people willing to
        learn! Join the funkies community to learn and earn in the Blockchain
        space!!
        <br />
      </span>
      <img src="img/m6.svg" alt="" className="story_image" />
    </section>
  );
}

export default About;
